import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Metoda płatności',
    [BillingMode.InternalInvoicing]: 'Wypłaty',
  },
};
